module.exports = __webpack_public_path__ + "img/social_icon_fb.ed15b5a2.svg";